import { errorHandlerFx } from '../../../../../../model/errorHandler';
import { createEffectJWT } from '../../../../../../model/JWT';
import { creativeCreate } from '../../../../../../apiRPC/creative';

export const creativeCreateFX = errorHandlerFx(createEffectJWT(creativeCreate));
